<template>
  <div class="safetyCenter">
    <router-view :userInfo = userInfo></router-view>
  </div>
</template>

<script>
export default {
  name: "safetyCenter",
  components: {},
  data() {
    return {};
  },
  props: {
    userInfo: {
      type: Object,
      default: {}
    }
  },
  mounted() {
    this.$parent.resetHeightFn()
  },
  computed: {},
  watch: {},
  methods: {},
  created() {},
  beforeCreate() {}
};
</script>
<style lang='scss' scoped>
</style>


// WEBPACK FOOTER //
// src/components/index/safetyCenter/index.vue